import React,  {Fragment} from 'react';
import {LogoBox} from "../user-menu/logo-box/logo-box.component";
import {observer} from 'mobx-react';
import {Button} from '../../basic-ui-components/button/base/button.component';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {GameSearchComponent} from '../game-search/game-search.component';
import {HeaderConfiguration} from '../../services/configurations/config-data-sections/header.configuration';
import {HelpButtonComponent} from './top-header-right/help-button/help-button.component';
import {CrossBrandsComponent} from './top-header-left/cross-brand/cross-brands.component';
import {RegulatoryDataComponent} from "./top-header-left/regulatory-data/regulatory-data.component";
import {MobileBurgerMenuComponent} from './top-header-left/mobile-burger-menu/mobile-burger-menu.component';
import {HeaderWelcomeButtonsComponent} from './top-header-right/header-welcome-buttons/header-welcome-buttons.component';
import {HeaderLanguageSwitcherComponent} from './top-header-right/language-switcher/header-language-switcher.component';
import {InsideOrbitMenuContainerComponent} from "../inside-orbit-menu-container/inside-orbit-menu-container.component";

import {NavbarSeparatorBox} from "./boxes/navbar-separator/navbar-separator.box";
import {HeaderNavbarContainerBox} from "./boxes/header-navbar-container/header-navbar-container.box";
import {HeaderNavbarMobileWrapperBox} from "./boxes/header-navbar-mobile-wrapper/header-navbar-mobile-wrapper.box";
import {HeaderNavbarLeftContainerBox} from "./boxes/navbar-left-container/header-navbar-left-container.box";
import {HeaderNavbarRightContainerBox} from "./boxes/navbar-right-container/header-navbar-right-container.box";
import {Image} from "../raw-components/image/image";
import {Link} from "../raw-components/link/link";

const NAVBAR_RIGHT_CONTAINER: string = "topHeaderRight";

@observer
export class HeaderComponent extends OrbitComponent {

    private get _headerConfig(): HeaderConfiguration {
        return this.services.configuration.data.header;
    }

    private _captureHeaderRef = (element: HTMLElement | null) => {
        this.services.header.setHeaderElement(element || null);
    };

    private _renderInsideOrbitMenuContainerPC() {

        if (this.services.device.isMobile) {
            return null;
        }

        return <InsideOrbitMenuContainerComponent/>;
    }

    private _renderDesktopSearchInput() {

        if (this.services.device.isMobile) {
            return null;
        }

        return <GameSearchComponent/>;
    }

    private _renderDesktopSafezoneButton() {

        if (!this.services.safezone.isEnabled) {
            return null;
        }

        return (
            <Button
                preset="flatStroked"
                icon={{Component: this.services.theme.currentTheme.icons.safeZoneIcon}}
                onClick={() => {
                    this.services.userMenu.closeMenu();
                    this.services.safezone.openFullSafezone()
                }}
                margin="0 0.4rem"
                tooltip={this.services.translation.translate('SAFE_GAMBLING_TOOLTIP')}
            />
        );
    }

    private _renderDesktopHelpButton() {

        if (this.services.device.isMobile) {
            return null;
        }

        return <HelpButtonComponent/>;
    }

    private _renderDesktopLanguageSwitcher() {

        if (this.services.device.isMobile || !this._headerConfig?.top_header_right?.languages?.display) {
            return null;
        }

        return <HeaderLanguageSwitcherComponent/>;
    }

    private _renderMobileNavbar() {
        return (
            <HeaderNavbarMobileWrapperBox ref={this._captureHeaderRef} className="cy-navbar-mobile-wrapper">
                <RegulatoryDataComponent/>
                <HeaderNavbarContainerBox className="cy-navbar-container">
                    <HeaderNavbarLeftContainerBox className="cy-navbar-left-container">
                        <MobileBurgerMenuComponent/>
                        <NavbarSeparatorBox className="cy-navbar-separator"/>
                        <LogoBox withAnalytics={true}/>
                    </HeaderNavbarLeftContainerBox>
                    <HeaderNavbarRightContainerBox className="cy-navbar-right-container">
                        <HeaderWelcomeButtonsComponent/>
                    </HeaderNavbarRightContainerBox>
                </HeaderNavbarContainerBox>
            </HeaderNavbarMobileWrapperBox>
        );
    }

    private _renderDesktopLeftNavbar() {
        return (
            <HeaderNavbarLeftContainerBox className="cy-navbar-left-container">
                {this._renderDesktopSearchInput()}
                {this._headerConfig?.responsibleIcons?.display === true &&
                this._headerConfig?.responsibleIcons?.position !== NAVBAR_RIGHT_CONTAINER && (
                    <Fragment>
                        <NavbarSeparatorBox/>
                        <RegulatoryDataComponent/>
                    </Fragment>)}
            </HeaderNavbarLeftContainerBox>
        );
    }

    private _renderDesktopRightNavbar() {
        return (
            <HeaderNavbarRightContainerBox className="cy-navbar-right-container">
                {this._renderInsideOrbitMenuContainerPC()}

                {this._headerConfig?.egr_logo?.display === true && (
                        <Fragment>
                            <Link href={this._headerConfig?.egr_logo?.link} preventDefaultOnClick={false} >
                                <Image src={this.services.theme.currentTheme.images.egrLogo.toString()} alt="EGR Winner 2021"/>
                            </Link>
                            <NavbarSeparatorBox/>
                        </Fragment>
                    )
                }

                {
                    this._headerConfig?.cross_brand?.display === true && (
                        <Fragment>
                            <CrossBrandsComponent/>
                            <NavbarSeparatorBox/>
                        </Fragment>
                    )
                }

                {this._headerConfig?.responsibleIcons?.display === true &&
                this._headerConfig?.responsibleIcons?.position === NAVBAR_RIGHT_CONTAINER && (
                    <Fragment>
                        <RegulatoryDataComponent/>
                        <NavbarSeparatorBox/>
                    </Fragment>
                )
                }
                {this._renderDesktopSafezoneButton()}
                {this._renderDesktopHelpButton()}
                {this._renderDesktopLanguageSwitcher()}
                <HeaderWelcomeButtonsComponent/>
            </HeaderNavbarRightContainerBox>
        );
    }

    render() {

        if (this.services.device.isMobile) {
            return this._renderMobileNavbar();
        }

        return (
            <HeaderNavbarContainerBox ref={this._captureHeaderRef} className="cy-navbar-container">
                {this._renderDesktopLeftNavbar()}
                {this._renderDesktopRightNavbar()}
            </HeaderNavbarContainerBox>
        );
    }
}
